module.exports = __webpack_public_path__ + "static/media/vrbex-logo-dark-background.edabe7ea.svg";